module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-800w.8c5e8b22.jpg";